import React from "react";
import { Api } from "../app-controller.js";
import { TabContent, TabPane, Nav, NavItem, NavLink } from "reactstrap";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import InfoForm from "../components/product-movements/InfoForm";
import classnames from "classnames";
import Swal from "sweetalert2";

class ProductMovementHistory extends React.Component {
  initialState = {
    previa: false,
    previa_url: "",
    modalState: false,
    working: true,
    workingModal: true,
    observationModalOpen: false,
    toggle: false,
    paginaActual: 0,
    bitacora_movimiento: "",
    paginaActual_vi: 0,
    paginas: 0,
    paginas_vi: 0,
    registros: 0,
    registros_vi: 0,
    movimientos: [],
    activeTab: "1",
    nivelUsuario: localStorage.nivel_actual,
    buscar: {},
    producto: "",
    cat_productos: [],
    presentacion: "",
    cat_presentacion: [],
    fecha_fabricacion: new Date().toISOString().split("T")[0],
    fecha_vencimiento: new Date().toISOString().split("T")[0],
    cat_actividad: Api.loadCatalogue("cat_actividad"),
    cantidad_lote: { cantidad: "", lote: "" },
    cantidades_lotes: [],
    fabricante: "",
    producto_valido: false,
    producto_sgi: "",
    productos_validados_listados: [],
    collapse: [
      {
        id: 1,
        collapse: true,
      },
      {
        id: 2,
        collapse: false,
      },
    ],
  };

  constructor(props) {
    super(props);

    this.state = this.initialState;
  }

  toggleTab = (tab) => {
    if (this.state.activeTab !== tab) {
      this.setState({ activeTab: tab });
    }
  };

  toggleCollapse = (index) => {
    var newArray = [];
    for (let collapseObj of this.state.collapse) {
      if (collapseObj.id === index) {
        collapseObj.collapse = !collapseObj.collapse;
      } else {
        collapseObj.collapse = false;
      }
      newArray.push(collapseObj);
    }

    this.setState({ collapse: newArray });
  };

  componentDidMount() {
    // si el usuario no es nivel drycip redireccionamos a home
    if (this.state.nivelUsuario !== "3") {
      window.location.href = "/";
    }

    this.setState({ buscar: this.search });
    this.getProductMovementHistory(1);
  }

  // Inicia logica que controla la pestaña de regente (grid y detalle)
  search = [];

  handleSearch = (evt) => {
    // Si el obj.target.name pertenece a un input type text aplicamos la funcion toUpperCase()
    [
      "folio_movimiento",
      "establecimiento_envia",
      "establecimiento_recibe",
      "fecha_solicitud",
      // "fecha_respuesta",
      "fecha_vencimiento",
    ].includes(evt.target.name)
      ? (this.search[evt.target.name] = evt.target.value.toUpperCase())
      : (this.search[evt.target.name] = evt.target.value);

    this.setState({ buscar: this.search });
  };

  // cleanSearch = () => {
  //   let search = this.state.buscar;

  //   for (const prop in search) {
  //     delete search[prop];
  //     document.getElementById(prop).value = "";
  //   }

  //   this.setState({ buscar: search });
  //   this.getProductMovementHistory(1);
  // };

  getControlledProductPresentation = (producto_id) => {
    Api.loading(true);
    Api.fetch("app/getProductPresentation?producto_id=" + producto_id)
      .then((data) => {
        if (data) {
          this.setState({ cat_presentacion: data });
        }
      })
      .then((data) => Api.loading(false));
  };

  getEstablecimientoFabricanteProducto = (producto_id) => {
    Api.loading(true);
    Api.fetch(
      "app/getEstablecimientoFabricanteProducto?producto_id=" + producto_id
    )
      .then((data) => {
        if (data) {
          this.setState({ fabricante: data });
        }
      })
      .then((data) => Api.loading(false));
  };

  //Funcion para cambiar de pagina en el grid de regente
  getProductMovementHistory = (page) => {
    this.setState({ workingGrid: true });
    let search = this.state.buscar;
    let src = "";
    for (let param in search) {
      if (search[param] !== "") {
        src += "&" + param + "=" + search[param];
      }
    }

    Api.fetch("app/getProductMovementHistory?page=" + page + src).then(
      (sol) => {
        this.setState({
          movimientos: sol.data,
          paginas: sol.last_page,
          registros: sol.total,
          paginaActual: sol.current_page,
          workingGrid: false,
        });
      }
    );
  };

  verifyProduct = (evt) => {
    evt.preventDefault();

    let cantidadLote = { ...this.state.cantidad_lote },
      producto = this.state.producto,
      presentacion = this.state.presentacion,
      bitacora_movimiento = this.state.bitacora_movimiento,
      producto_valido = this.initialState.producto_valido;

    if (!cantidadLote.lote) {
      this.validateSingleError("lote", "Ingrese lote.");
    }

    if (!producto) {
      this.validateSingleError("producto", "Seleccione");
    }

    if (!presentacion) {
      this.validateSingleError("presentacion", "Seleccione");
    }

    if (cantidadLote.lote && producto && presentacion) {
      Api.loading(true);

      Api.fetch(
        "app/verifyProduct?lote=" +
          cantidadLote.lote +
          "&producto_id=" +
          producto.id +
          "&presentacion_id=" +
          presentacion.id +
          "&establecimiento_id=" +
          bitacora_movimiento.establecimiento_envia_id
      ).then((data) => {
        if (data && Object.keys(data).length > 0) {
          producto_valido = true;
          this.setState({
            producto_valido: producto_valido,
            producto_sgi: data,
          });
          Api.loading(false);
        } else {
          Swal.fire({
            icon: "warning",
            title: "¡Producto no encontrado!",
            text: "No se encontró producto con las especificaciones ingresadas",
            confirmButtonText: "Regresar",
            timer: 5000,
          });
        }
      });
    }
  };

  validateSingleError = (el, msg) => {
    document.getElementById(el + "-error").style.display = "block";
    document.getElementById(el + "-error").innerText = msg;
    document.getElementById(el).classList.add("is-invalid");
  };

  handleListaRecetasElectronicasPage = (e) => {
    this.getProductMovementHistory(e.target.value);
  };

  handleModalCloseBtn = (evt) => {
    evt.preventDefault();

    this.setState({
      workingModal: true,
      bitacora_movimiento: "",
      modalState: false,
    });
  };

  handlePrevia = (e) => {
    let doc = e.target.getAttribute("data-file");
    this.setState({ previa: true, previa_url: doc });
  };

  handleProductChange = (obj) => {
    // reiniciamos presentacion en caso de que tenga un valor, y asignamos otros valores correspondientes al objeto de productos
    let cantidadLote = this.state.cantidad_lote;
    cantidadLote.cantidad = this.initialState.cantidad_lote.cantidad;
    this.setState({
      producto: obj,
      presentacion: this.initialState.presentacion,
      cantidad_lote: cantidadLote,
      producto_valido: this.initialState.producto_valido,
      // presentacion: this.initialState.presentacion,
    });

    // limpamos errores si es que los hay
    this.cleanErrorsValidation("producto");
    this.cleanErrorsValidation("presentacion");
    this.cleanErrorsValidation("fabricante");
    // buscamos la/las presentaciones del producto
    this.getControlledProductPresentation(obj.id);
    this.getEstablecimientoFabricanteProducto(obj.id);
  };

  handleFechaChange = (evt) => {
    if (evt.target.name === "fecha_fabricacion") {
      this.setState({ fecha_fabricacion: evt.target.value });
    }

    if (evt.target.name === "fecha_vencimiento") {
      this.setState({ fecha_vencimiento: evt.target.value });
    }
  };

  handlePresentationChange = (obj) => {
    // limpamos errores si es que los hay
    this.cleanErrorsValidation("presentacion");

    let cantidadLote = { ...this.state.cantidad_lote };
    cantidadLote.cantidad = "";

    // le damos el valor del objeto de presentación seleccionado a presentacion
    this.setState({
      presentacion: obj,
      producto_valido: this.initialState.producto_valido,
      cantidad_lote: cantidadLote,
    });
  };

  openModalForm = (evt) => {
    this.setState({ modalState: true });
    //buscamos la bitacora de movimiento
    Api.fetch(
      "app/getBitacoraMovimiento?id=" +
        evt.target.id +
        "&ver_movimiento_completo=" +
        1
    )
      .then((data) => {
        if (data) {
          this.setState({
            bitacora_movimiento: data,
          });
        }
      })
      .then((res) => {
        this.setState({ workingModal: false });
      });
  };

  handleSubmit = (evt) => {
    evt.preventDefault();

    let movementData = {
      ...this.state,
    };

    delete movementData.cat_presentacion;
    delete movementData.cat_productos;
    delete movementData.collapse;
    delete movementData.activeTab;
    delete movementData.buscar;
    delete movementData.modalState;
    delete movementData.nivelUsuario;
    delete movementData.observationModalOpen;
    delete movementData.paginaActual;
    delete movementData.paginaActual_vi;
    delete movementData.paginas;
    delete movementData.paginas_vi;
    delete movementData.previa_url;
    delete movementData.producto_valido;
    delete movementData.registros;
    delete movementData.registros_vi;
    delete movementData.toggle;
    delete movementData.working;
    delete movementData.workingGrid;
    delete movementData.workingModal;
    delete movementData.previa;
    delete movementData.cantidad_lote;
    delete movementData.producto_sgi;
    delete movementData.cantidades_lotes;

    Swal.fire({
      icon: "question",
      title: "¿Completar transacción?",
      text: "¡Asegúrese que los datos estén completados correctamente!",
      showDenyButton: true,
      denyButtonColor: "red",
      confirmButtonColor: "#4CD964",
      showCancelButton: false,
      confirmButtonText: `Continuar`,
      denyButtonText: `Regresar`,
      reverseButtons: true,
    }).then((result) => {
      let cantidadesLotes = this.state.cantidades_lotes;
      if (cantidadesLotes === 0) {
        this.fireSwal(
          "¡Debe ingresar por lo menos una cantidad y lote para poder generar la venta!",
          "warning"
        );
      } else {
        if (result.isConfirmed) {
          this.submitForm(movementData);
        }
      }
    });
  };

  submitForm = (movementData) => {
    Api.loading(true);
    Api.fetch("app/storeMovementLogs", movementData, "POST").then((data) => {
      if (data.errors) {
        this.handleValidations(data.errors);
        Api.loading(false);
        this.fireSwal(
          "¡Verifique que los datos esten correctamente completados!",
          "warning"
        );
        return false;
      } else {
        Api.loading(false);
        Swal.fire({
          icon: "success",
          title: "¡La información ha sido almacenada exitosamente!",
          timer: 3000,
          confirmButtonText: "Continuar",
        }).then(() => {
          window.location.href = "/movimientos-productos/egresos";
        });
        this.resetStates();
      }
    });
  };

  // fn para reiniciar todos los estados una vez el submit sea éxitoso
  resetStates = () => {
    this.setState({
      producto: this.initialState.producto,
      presentacion: this.initialState.presentacion,
      bitacora_movimiento: this.initialState.bitacora_movimiento,
      fecha_fabricacion: this.initialState.fecha_fabricacion,
      fecha_vencimiento: this.initialState.fecha_vencimiento,
      fabricante: this.initialState.fabricante,
      productos_validados_listados:
        this.initialState.productos_validados_listados,
      cantidad_lote: this.initialState.cantidad_lote,
      producto_sgi: this.initialState.producto_sgi,
      cantidades_lotes: this.initialState.cantidades_lotes,
      producto_valido: this.initialState.producto_valido,
    });
  };

  addCantidadLote = (evt) => {
    evt.preventDefault();

    let cantidadLote = { ...this.state.cantidad_lote },
      cantidadesLotes = [...this.state.cantidades_lotes],
      productoSGI = { ...this.state.producto_sgi },
      productosValidadosListados = [...this.state.productos_validados_listados];

    if (!cantidadLote.cantidad) {
      this.validateSingleError("cantidad", "Ingrese cantidad.");
    }

    if (cantidadLote.cantidad === 0) {
      this.validateSingleError("cantidad", "La cantidad debe ser mayor a 0.");
    }

    if (!cantidadLote.lote) {
      this.validateSingleError("lote", "Ingrese lote.");
    }

    if (cantidadLote.cantidad && cantidadLote.lote) {
      // validamos que el lote a ingresar no se encuentra en la lista de lotes ya listados
      if (cantidadesLotes.find((obj) => obj.lote === cantidadLote.lote)) {
        Swal.fire({
          icon: "warning",
          title: "¡Atención!",
          text: `El lote ${cantidadLote.lote} ya se encuentra listado`,
          timer: 5000,
        });
        this.validateSingleError("lote", "Lote ya listado.");
      } else {
        // calculamos cantidad de cgi con las que se quieren ingresar
        let cantidadLoteInt = parseInt(cantidadLote.cantidad),
          cantidadSGI = parseInt(productoSGI.cantidad),
          cantidadRestante = 0;

        if (cantidadSGI === 0) {
          Swal.fire({
            icon: "warning",
            title: "¡Atención!",
            text: `El lote ${cantidadLote.lote} cuenta con 0 existencias actualmente.`,
            timer: 5000,
          });
        } else {
          cantidadRestante = cantidadSGI - cantidadLoteInt;

          if (cantidadRestante < 0) {
            Swal.fire({
              icon: "warning",
              title: "¡Atención!",
              text: `El lote ${cantidadLote.lote} sólo cuenta con ${cantidadSGI} existencias actualmente.`,
              timer: 5000,
            });
          } else {
            productoSGI.cantidad = cantidadRestante;

            productoSGI["cantidad_solicitada"] = cantidadLoteInt;
            cantidadesLotes.push(cantidadLote);
            productosValidadosListados.push(productoSGI);

            this.setState({
              cantidades_lotes: cantidadesLotes,
              // cantidad_lote: this.initialState.cantidad_lote,
              // producto_sgi: this.initialState.productoSGI,
              productos_validados_listados: productosValidadosListados,
            });
          }
        }
      }
    }
  };

  removeCantidadLote = (evt) => {
    let cantidadesLotes = [...this.state.cantidades_lotes],
      productosValidadosListados = [...this.state.productos_validados_listados];

    cantidadesLotes.splice(evt.target.id, 1);
    productosValidadosListados.splice(evt.target.id, 1);

    this.setState({
      cantidades_lotes: cantidadesLotes,
      productos_validados_listados: productosValidadosListados,
    });
  };

  // fn para marcar los campos que duevelen error desde la api
  handleValidations = (errors) => {
    for (const i in errors) {
      document.getElementById(i + "-error").style.display = "block";
      document.getElementById(i + "-error").innerText = errors[i];
      document.getElementById(i).classList.add("is-invalid");
    }
  };

  // fn para depslegar mensajes de alerta sencillos
  fireSwal(title, icon = "error") {
    Swal.fire({
      title: title,
      icon: icon,
      timer: 5000,
      confirmButtonText: "Regresar",
    });
    return false;
  }

  handleCantidadLote = (evt) => {
    let inputName = evt.target.name,
      inputValue = evt.target.value,
      cantidadLote = { ...this.state.cantidad_lote },
      producto_valido = this.state.producto_valido;

    if (inputName === "cantidad") {
      if (this.checkPositiveIntegers(inputValue)) {
        // limpamos errores si es que los hay
        this.cleanErrorsValidation(inputName);
        cantidadLote.cantidad = inputValue;
        this.setState({ cantidad_lote: cantidadLote });
      }
    }

    if (inputName === "lote") {
      // limpamos errores si es que los hay
      this.cleanErrorsValidation(inputName);
      cantidadLote.lote = inputValue.toUpperCase();

      if (producto_valido) {
        cantidadLote.cantidad = "";
      }

      this.setState({
        cantidad_lote: cantidadLote,
        producto_valido: this.initialState.producto_valido,
      });
    }
  };

  /*********** Funciones ***********/

  // funcion para validar solo enteros positivos en un input
  checkPositiveIntegers = (str) => {
    let regex = /^[1-9]\d{0,6}$/,
      response = false;

    if (str === "" || regex.test(str)) {
      response = true;
    }

    return response;
  };

  // fn para limpar errores cuando cambie el estado del input que los tenga
  cleanErrorsValidation = (elemento) => {
    let divError = document.getElementById(elemento + "-error"),
      classInvalid = document.getElementById(elemento);

    if (divError && classInvalid) {
      divError.style.display = "none";
      divError.innerText = "";
      classInvalid.classList.remove("is-invalid");
    }
  };

  render() {
    return (
      <div className="row">
        <div className="col-xl-12">
          <Nav tabs={true}>
            <NavItem>
              <NavLink
                className={classnames({
                  active: this.state.activeTab === "1",
                })}
                onClick={() => {
                  this.toggleTab("1");
                }}
              >
                <span className="d-sm-none">
                  MOVIMIENTOS
                  <span className="label label-success m-l-5 t-minus-1">
                    {this.state.registros}
                  </span>
                </span>
                <span className="d-sm-block d-none">
                  MOVIMIENTOS
                  <span className="label label-success m-l-5 t-minus-1">
                    {this.state.registros}
                  </span>
                </span>
              </NavLink>
            </NavItem>
          </Nav>
          <TabContent activeTab={this.state.activeTab}>
            <TabPane tabId="1">
              <div className="table-responsive">
                <fieldset>
                  <legend>Buscar</legend>

                  <div className="row">
                    <div className="col-lg-3">
                      <div className="form-group">
                        <label htmlFor="establecimiento_envia">
                          Establecimiento envía:
                        </label>
                        <div className="form-group">
                          <input
                            id="establecimiento_envia"
                            name="establecimiento_envia"
                            onChange={this.handleSearch}
                            placeholder="Ingrese establecimiento"
                            className="form-control"
                            type="text"
                          />
                        </div>
                      </div>
                    </div>

                    <div className="col-lg-3">
                      <div className="form-group">
                        <label htmlFor="actividad_envia">
                          Actividad envía:
                        </label>
                        <select
                          name="actividad_envia"
                          id="actividad_envia"
                          className="form-control"
                          onChange={this.handleSearch}
                          placeholder="Ingrese actividad"
                        >
                          <option value="">Seleccione actividad</option>
                          {this.state.cat_actividad.map((item) => (
                            <option key={item.id} value={item.id}>
                              {item.descripcion.toUpperCase()}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>

                    {/* <div className="col-lg-3">
                      <div className="form-group">
                        <label htmlFor="fecha_respuesta">
                          Fecha respuesta:
                        </label>
                        <input
                          type="date"
                          name="fecha_respuesta"
                          onChange={this.handleSearch}
                          id="fecha_respuesta"
                          className="form-control"
                          placeholder="Fecha"
                        />
                      </div>
                    </div> */}

                    <div className="col-lg-3">
                      <div className="form-group">
                        <label htmlFor="establecimiento_recibe">
                          Establecimiento recibe:
                        </label>
                        <input
                          id="establecimiento_recibe"
                          name="establecimiento_recibe"
                          onChange={this.handleSearch}
                          placeholder="Ingrese establecimiento"
                          className="form-control"
                          type="text"
                        />
                      </div>
                    </div>

                    <div className="col-lg-3">
                      <div className="form-group">
                        <label htmlFor="actividad_recibe">
                          Actividad recibe:
                        </label>
                        <select
                          name="actividad_recibe"
                          id="actividad_recibe"
                          className="form-control"
                          onChange={this.handleSearch}
                          placeholder="Ingrese actividad"
                        >
                          <option value="">Seleccione actividad</option>
                          {this.state.cat_actividad.map((item) => (
                            <option key={item.id} value={item.id}>
                              {item.descripcion.toUpperCase()}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-lg-3">
                      <div className="form-group">
                        <label htmlFor="folio_movimiento">
                          Folio movimiento:
                        </label>
                        <input
                          id="folio_movimiento"
                          name="folio_movimiento"
                          placeholder="Ingrese folio"
                          onChange={this.handleSearch}
                          className="form-control"
                          type="text"
                        />
                      </div>
                    </div>

                    <div className="col-lg-3">
                      <div className="form-group">
                        <label htmlFor="estatus">Estado:</label>
                        <select
                          name="estatus"
                          id="estatus"
                          className="form-control"
                          onChange={this.handleSearch}
                        >
                          <option value="">Seleccione estatus</option>
                          <option value="5">ACEPTADA</option>
                          <option value="9">EN ESPERA SINAIP</option>
                          <option value="15">EN ESPERA MOVIMIENTO</option>
                          <option value="4">RECHAZADA</option>
                        </select>
                      </div>
                    </div>

                    <div className="col-lg-3">
                      <div className="form-group">
                        <label htmlFor="fecha_solicitud">
                          Fecha de solicitud:
                        </label>
                        <input
                          type="date"
                          name="fecha_solicitud"
                          onChange={this.handleSearch}
                          id="fecha_solicitud"
                          className="form-control"
                          placeholder="Fecha"
                        />
                      </div>
                    </div>

                    <div className="col-lg-3">
                      <div className="form-group">
                        <label htmlFor="search">&nbsp;</label>
                        <button
                          type="button"
                          className="btn btn-orange w-100"
                          title="Buscar"
                          onClick={() => this.getProductMovementHistory(1)}
                        >
                          <i className="fa fa-search"></i> Buscar
                        </button>
                      </div>
                    </div>

                    {/* <div className="col-lg-3">
                      <div className="form-group">
                        <label htmlFor="search">&nbsp;</label>
                        <div className="input-group">
                          <button
                            type="button"
                            className="btn btn-blue w-100"
                            title="Limpiar"
                            onClick={this.cleanSearch}
                          >
                            <i className="fas fa-trash-alt"></i> Limpiar
                          </button>
                        </div>
                      </div>
                    </div> */}
                  </div>
                </fieldset>
                <table className="table table-striped m-b-0 table-hover">
                  <thead>
                    <tr>
                      <th className="text-center">Folio movimiento</th>
                      <th className="text-center">Establecimiento envía</th>
                      <th className="text-center">Actividad envía</th>
                      <th className="text-center">Establecimiento recibe</th>
                      <th className="text-center">Actividad recibe</th>
                      <th className="text-center">Fecha solicitud</th>
                      <th className="text-center">Estado</th>
                      {/* <th className="text-center">Fecha respuesta</th> */}
                      <th className="text-center"></th>
                    </tr>
                  </thead>
                  <tbody className={this.state.workingGrid ? "hide" : ""}>
                    {this.state.movimientos &&
                    this.state.movimientos.length > 0 ? (
                      this.state.movimientos.map((sol) => (
                        <tr key={sol.id}>
                          <td className="text-center">
                            {sol.folio_movimiento}
                          </td>
                          <td className="text-center">
                            {sol.establecimiento_envia_nombre}
                          </td>
                          <td className="text-center">
                            {sol.actividad_envia["descripcion"]}
                          </td>
                          <td className="text-center">
                            {sol.establecimiento_recibe_nombre}
                          </td>
                          <td className="text-center">
                            {sol.actividad_recibe["descripcion"]}
                          </td>
                          <td className="text-center">
                            {sol.fecha_solicitada}
                          </td>
                          {/* <td className="text-center">
                            {sol.acepto === "1"
                              ? "Aceptada"
                              : sol.acepto === "0"
                              ? "Rechazada"
                              : "Pendiente"}
                          </td> */}
                          <td className="text-center">{sol.estatus_tramite}</td>
                          <td className="text-center">
                            {sol.formulario_envio === "1" ? (
                              <div className="btn-group">
                                <button
                                  onClick={this.openModalForm}
                                  id={sol.id}
                                  title="Ver información del movimiento"
                                  className="btn bg-gradient-blue"
                                >
                                  <i id={sol.id} className="fas fa-eye"></i>
                                </button>
                              </div>
                            ) : null}
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="9" className="text-center">
                          No se encontraron resultados
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
                <div className={this.state.workingGrid ? "m-10" : "hide"}>
                  <div className="progress-bar bg-orange progress-bar-striped progress-bar-animated">
                    CARGANDO INFORMACIÓN
                  </div>
                </div>
                <hr />
                <div className="d-flex align-items-center justify-content-center">
                  <ul className="pagination mb-0">
                    <li className="page-item">
                      <button
                        onClick={() => {
                          this.getProductMovementHistory(1);
                        }}
                        className="page-link"
                      >
                        <i className="fa fa-angle-double-left"></i>
                      </button>
                    </li>
                    <li className="page-item">
                      <button
                        onClick={() => {
                          if (this.state.paginaActual - 1 > 0) {
                            this.getProductMovementHistory(
                              this.state.paginaActual - 1
                            );
                          }
                        }}
                        className="page-link"
                      >
                        <i className="fa fa-angle-left"></i>
                      </button>
                    </li>
                    <li className="page-item d-flex align-items-center px-2">
                      <div>
                        Página
                        <strong>
                          {" "}
                          {this.state.paginaActual} de {this.state.paginas}
                        </strong>
                      </div>
                    </li>
                    <li className="page-item">
                      <button
                        onClick={() => {
                          if (
                            this.state.paginas >=
                            this.state.paginaActual + 1
                          ) {
                            this.getProductMovementHistory(
                              this.state.paginaActual + 1
                            );
                          }
                        }}
                        className="page-link"
                      >
                        <i className="fa fa-angle-right"></i>
                      </button>
                    </li>
                    <li className="page-item">
                      <button
                        onClick={() => {
                          this.getProductMovementHistory(this.state.paginas);
                        }}
                        className="page-link"
                      >
                        <i className="fa fa-angle-double-right"></i>
                      </button>
                    </li>
                  </ul>
                  <div className="ml-3 mr-1">Página:</div>
                  <div className="width-50 mx-2">
                    <input
                      className="form-control"
                      onChange={this.handleListaRecetasElectronicasPage}
                      type="number"
                      min="1"
                      max={this.state.paginas}
                      value={this.state.paginaActual}
                    />
                  </div>
                  <div></div>
                </div>
              </div>
            </TabPane>
          </TabContent>
        </div>
        <Modal
          isOpen={this.state.modalState}
          tabIndex="-1"
          style={{
            maxWidth: "100%",
            width: "80%",
          }}
        >
          <ModalHeader
            width="100%"
            toggle={() => {
              this.setState({
                modalState: false,
                workingModal: true,
                bitacora_movimiento: "",
              });
              this.resetStates();
            }}
            className="text-center"
          >
            {this.state.bitacora_movimiento
              ? `Folio: ${this.state.bitacora_movimiento.folio_movimiento}`
              : null}
          </ModalHeader>
          <ModalBody>
            <InfoForm
              bitacora_movimiento={this.state.bitacora_movimiento}
              workingModal={this.state.workingModal}
              handlePrevia={this.handlePrevia}
            />
          </ModalBody>
          {/* <ModalFooter>
              <div className="container">
                <div className="row">
                  <div className="col-lg-12">
                    <button
                      onClick={this.handleModalCloseBtn}
                      className="btn btn-danger float-right"
                    >
                      Regresar
                    </button>
                  </div>
                </div>
              </div>
            </ModalFooter> */}
        </Modal>
        <div className={this.state.previa ? "previa" : "hide"}>
          <iframe
            title="Vista previa"
            className="rounded"
            src={this.state.previa_url}
          ></iframe>
          <center>
            <div className="btn-group">
              <button
                onClick={() => {
                  this.setState({
                    previa: this.initialState.previa,
                    previa_url: this.initialState.previa_url,
                  });
                }}
                className="btn btn-danger"
              >
                Regresar
              </button>
              <a
                className="btn btn-primary"
                href={this.state.previa_url + "&download=1"}
                download="download"
              >
                Descargar
              </a>
            </div>
          </center>
        </div>
      </div>
    );
  }
}

export default ProductMovementHistory;
